// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TeOjA","flex":"styles_flex__twOvv"};